<!-- TODO: add hasViewPermission when regions are mapped to poolSets -->
<div [class]="filter">
  <div class="header">
    <span>Select a Location</span>
    <span (click)="closeDialog()"><mat-icon>close</mat-icon></span>
  </div>

  @if ((showRegionTypeToggle$ | async) === false) {
  <div class="continent-region-selection">
    <span class="continent-text">Continent</span>
    <span [matMenuTriggerFor]="contMenu" class="continent-trigger"
      >{{ continentText$ | async | titlecase }} <mat-icon>expand_more</mat-icon>
    </span>
  </div>
  } @if (showRegionTypeToggle$ | async) {
  <div class="continent-region-selection">
    <span [matMenuTriggerFor]="contMenu" class="continent-trigger"
      >{{ continentText$ | async | titlecase }} <mat-icon>expand_more</mat-icon>
    </span>
    <span class="continent-text">Region Type</span>
    <firebird-web-dropdown
      [options]="data?.regionTypeDataSource || []"
      [value]="selectedRegionType"
      type="variation-five"
      (changeEvent)="changeRegionType($event)"
    >
    </firebird-web-dropdown>
  </div>
  } @if (regionList$ | async; as regionLists) {
  <div class="regions">
    @if (filter === 'degree' && primaryLens === 'ag2Forecast') {
    <div class="regions-container">
      @if (summaryView) {
      <div
        class="region summary-region"
        (click)="onRegionSelected(summaryView)"
      >
        {{ summaryView.text }}
      </div>
      }
    </div>
    }
    <div class="regions-container-wrapper">
      @for (regionList of regionLists; track regionList) {
      <div class="regions-container">
        @for (region of regionList; track trackByFnGroup($index)) {
        <div class="region" (click)="onRegionSelected(region)">
          {{ region.text }}
        </div>
        }
      </div>
      }
    </div>
  </div>
  }

  <mat-menu #contMenu="matMenu">
    @for (continent of continentList; track continent) {
    <button
      mat-menu-item
      class="continent-selection-btn"
      (click)="onContinentChange(continent)"
      [attr.aria-label]="continent.text"
    >
      <span
        [hasViewPermission]="continent.permission ?? [continent.id]"
        [key]="continentPermissionKey"
        [alignRight]="true"
      >
        {{ continent.text }}
      </span>
    </button>
    }
  </mat-menu>
</div>
